export const DEFAULT_FORMATTER_LOCALE = 'en_US'
